export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';
export const DELETE_NOTIFICATIONS = 'DELETE_NOTIFICATIONS'

const NOTIFICATION_DURATION = 5000;

export const clearNotifications = {
  type: CLEAR_NOTIFICATIONS,
}

export const setNotifications = (data) => {
  return (dispatch) => {
    dispatch({
      type: SET_NOTIFICATIONS,
      payload: data,
    });

    setTimeout(() => {
      dispatch(clearNotifications);
    }, NOTIFICATION_DURATION);
  };
}

export const deleteNotifications = (data) => {
  return {
    type: DELETE_NOTIFICATIONS,
    payload: data
  }
}